"use strict";

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.array.find.js");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  try {
    var elementStyle = document.createElement('style');
    elementStyle.innerText = ".select-checkbox, .select-all-checkbox {\n  cursor: pointer;\n}\n.vdtnet-footer .dataTables_length {\n  padding-top: 6px;\n  padding-right: 10px;\n}\n.vdtnet-footer .dataTables_length, .vdtnet-footer .dataTables_paginate {\n  float: right;\n}\n.hide-footer .vdtnet-footer {\n  display: none;\n}\n.master .details-plus\n{\n  cursor: pointer;\n  display: none;\n}\n.details-minus\n{\n  cursor: pointer;\n  display: none;\n}\n.master .details-minus\n{\n  cursor: pointer;\n  display: inline;\n}\n.details-control {\n  cursor: pointer;\n  font-weight: 700;\n}";
    document.head.appendChild(elementStyle);
  } catch (e) {
    console.error('vite-plugin-css-injected-by-js', e);
  }
})();

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : (0, _typeof2.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('vue')) : typeof define === 'function' && define.amd ? define(['vue'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.VdtnetTable = factory(global.Vue));
})(void 0, function (vue) {
  'use strict';

  var VdtnetTable_vue_vue_type_style_index_0_lang = '';

  var _export_sfc = function _export_sfc(sfc, props) {
    var target = sfc.__vccOpts || sfc;

    var _iterator = _createForOfIteratorHelper(props),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
            key = _step$value[0],
            val = _step$value[1];

        target[key] = val;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return target;
  };

  var myUniqueId = 1;
  var _sfc_main = {
    name: 'VdtnetTable',
    props: {
      /**
       * The table id
       *
       * @type String
       */
      id: {
        type: String,
        default: null
      },

      /**
       * Set the container classes.
       *
       * @type String
       */
      containerClassName: {
        type: String,
        default: 'table-responsive d-print-inline'
      },

      /**
       * Set the input column search classes.
       *
       * @type String
       */
      columnSearchClassName: {
        type: String,
        default: 'form-control form-control-sm'
      },

      /**
       * Set the tfoot classes.
       *
       * @type String
       */
      tfootClassName: {
        type: String
      },

      /**
       * Set the thead classes.
       *
       * @type String
       */
      theadClassName: {
        type: String
      },

      /**
       * Set the table classes you wish to use, default with bootstrap5
       * but you can override with: themeforest, foundation, etc..
       *
       * @type String
       */
      className: {
        type: String,
        default: 'table table-striped table-bordered nowrap w-100'
      },

      /**
       * the options object: https://datatables.net/manual/options
       *
       * @type Object
       */
      opts: {
        type: Object
      },

      /**
       * List all fields to be converted to opts columns
       *
       * @type Object
       */
      fields: {
        type: Object
      },

      /**
       * Pass in DataTables.Net jQuery to resolve any conflict from
       * multiple jQuery loaded in the browser
       *
       * @type Function
       */
      jquery: {
        type: Function
      },

      /**
       * The select-checkbox column index (start at 1)
       * Current implementation require datatables.net-select
       *
       * @type Number
       */
      selectCheckbox: {
        type: Number,
        default: -1
      },

      /**
       * Provide custom local data loading.  Warning: this option has not been
       * thoroughly tested.  Please use ajax and serverSide instead.
       *
       * @type Function
       */
      dataLoader: {
        type: Function
      },

      /**
       * true to hide the footer of the table
       *
       * @type Boolean
       */
      hideFooter: {
        type: Boolean
      },

      /**
       * true to hide the tfoot of the table
       *
       * @type Boolean
       */
      hideTfoot: {
        type: Boolean,
        default: true
      },

      /**
       * true to hide the individual column search of the table
       *
       * @type Boolean
       */
      columnSearch: {
        type: Boolean,
        default: false
      },

      /**
       * The details column configuration of master/details.
       *
       * @type {Object}
       */
      details: {
        type: Object
      }
    },
    data: function data() {
      // initialize defaults
      return {
        tableId: null,
        options: {
          /*eslint-disable */
          dom: "tr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",

          /*eslint-enable */
          columns: [],
          language: {
            infoFiltered: ''
          },
          lengthMenu: [[15, 100, 500, 1000, -1], [15, 100, 500, 1000, 'All']],
          pageLength: 15,
          buttons: [] // remove any button defaults

        },
        dataTable: null,
        vdtnet: this
      };
    },
    computed: {
      jq: function jq() {
        return this.jquery || window.jQuery;
      },
      classes: function classes() {
        var that = this;
        var classes = "".concat(that.containerClassName, " vdtnet-container");

        if (this.hideFooter) {
          classes += ' hide-footer';
        }

        return classes;
      }
    },
    created: function created() {
      var that = this;
      var jq = that.jq;
      var startCol = 0;
      var icol = 0;
      that.tableId = that.id || "vdtnetable".concat(myUniqueId++); // allow user to override default options

      if (that.opts) {
        that.options = jq.extend({}, that.options, that.opts);
      }

      that.options.order = that.options.order || [[startCol, 'asc']];

      if (that.fields) {
        var fields = that.fields;
        var cols = that.options.columns;
        var orders = that.options.order;

        for (var k in fields) {
          var field = fields[k];
          field.name = field.name || k; // disable search and sort for local field

          if (field.isLocal) {
            field.searchable = false;
            field.sortable = false;
          } // generate


          var col = {
            label: field.label || field.name,
            data: field.data || field.name,
            width: field.width,
            name: field.name,
            className: field.className,
            index: field.index || icol + 1
          };

          if (field.hasOwnProperty('defaultContent')) {
            col.defaultContent = field.defaultContent;
          }

          if (field.hasOwnProperty('sortable')) {
            col.orderable = field.sortable;
          }

          if (field.hasOwnProperty('visible')) {
            col.visible = field.visible;
          }

          if (field.hasOwnProperty('searchable')) {
            col.searchable = field.searchable;
          }

          if (field.hasOwnProperty('editField')) {
            col.editField = field.editField;
          }

          if (field.hasOwnProperty('classHeaderName')) {
            col.classHeaderName = field.classHeaderName;
          }

          if (field.hasOwnProperty('classFooterName')) {
            col.classFooterName = field.classFooterName;
          }

          if (field.template) {
            col.template = field.template;
          }

          if (field.render) {
            col.render = field.render;
          } // console.log(col)


          cols.push(col);

          if (field.defaultOrder) {
            orders.push([icol, field.defaultOrder]);
          }

          icol++;
        }
      }

      if (that.selectCheckbox) {
        // create checkbox column
        var _col = {
          orderable: false,
          searchable: false,
          name: '_select_checkbox',
          className: 'select-checkbox d-print-none',
          data: null,
          defaultContent: '',
          index: that.selectCheckbox - 1
        };
        that.options.columns.splice(that.selectCheckbox - 1, 0, _col); // console.log(that.options.columns)

        that.options.select = that.options.select || {
          style: 'os',
          selector: 'td.select-checkbox'
        };

        if (that.selectCheckbox === 1) {
          startCol++;
        }
      } // handle master details


      if (that.details) {
        var detailsIndex = that.details.index || 1; // create details column

        var _col2 = {
          orderable: false,
          searchable: false,
          name: '_details_control',
          className: 'details-control d-print-none',
          data: null,
          defaultContent: that.details.icons || '<span class="details-plus" title="Show details">+</span><span class="details-minus" title="Hide details">-</span>',
          index: detailsIndex - 1
        };
        that.options.columns.splice(detailsIndex - 1, 0, _col2);

        if (detailsIndex === 1) {
          startCol++;
        }
      }

      if (startCol > 0) {
        if (that.options.order) {
          that.options.order.forEach(function (v) {
            v[0] += startCol;
          });
        } else {
          that.options.order = [[startCol, 'asc']];
        }
      }
    },
    mounted: function mounted() {
      var that = this;
      var jq = that.jq;
      var $el = jq(that.$refs.table);
      var cols = that.options.columns;

      for (var k in cols) {
        var col = cols[k];

        if (col.template || typeof that.$slots[col.name] === 'function') {
          col.render = that.compileTemplate(col, that.$slots[col.name]);
        }

        if (col.render) {
          if (!col.render.templated) {
            (function () {
              var myRender = col.render;

              col.render = function () {
                return myRender.apply(that, Array.prototype.slice.call(arguments));
              };
            })();
          }
        }
      } // handle local data loader


      if (that.dataLoader) {
        delete that.options.ajax;
        that.options.serverSide = false;
      }

      if (!that.hideFooter && that.columnSearch) {
        that.options.initComplete = function () {
          var api = this.api();
          var state = api.state.loaded();
          api.columns().every(function () {
            var that = this;
            var colIdx = this.index();

            if (state) {
              var colSearch = state.columns[colIdx].search;

              if (colSearch.search) {
                jq('input', this.footer()).val(colSearch.search);
              }
            }

            jq('input', this.footer()).on('keyup change clear search', function () {
              if (that.search() !== this.value) {
                that.search(this.value).draw();
              }
            });
          });
        };
      } // you can access and update the that.options and $el here before we create the DataTable


      that.$emit('table-creating', that, $el);
      that.dataTable = $el.DataTable(that.options);

      if (that.selectCheckbox) {
        // handle select all checkbox
        $el.on('click', 'th input.select-all-checkbox', function (e) {
          if (jq(e.target).is(':checked')) {
            that.dataTable.rows().select();
          } else {
            that.dataTable.rows().deselect();
          }
        }); // handle individual row select events

        that.dataTable.on('select deselect', function (e, dt, type, indexes) {
          var $input = $el.find('th input.select-all-checkbox');

          if (that.dataTable.rows({
            selected: true
          }).count() !== that.dataTable.rows().count()) {
            jq('th.select-checkbox').removeClass('selected');
            $input.attr('checked', false);
          } else {
            jq('th.select-checkbox').addClass('selected');
            $input.attr('checked', true);
          } // type is select/deselect so event become row-select or row-deselect


          that.$emit('row-' + e.type, {
            dataTable: that.dataTable,
            e: e,
            dt: dt,
            type: type,
            indexes: indexes
          }); // to get data, see const examples below
          // const rows = event.dataTable.rows( event.indexes )
          // const data = rows.data()
        });
      }

      $el.on('remove', function () {
        if (that.dataTable) {
          that.dataTable.destroy(true);
        }

        that.dataTable = null;
      }); // wire up edit, delete, and/or action buttons

      $el.on('click', '[data-action]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var target = jq(e.currentTarget);
        var action = target.attr('data-action'); // no action, simply exit

        if (!action) {
          return;
        } else {
          var tr = target; // detect if action is inside a row
          // get data from parent row/tr

          if (target.prop('tagName') !== 'TR') {
            tr = target.closest('tr');
          }

          if (tr) {
            // if child row, get previous/parent row
            if (tr.hasClass('master-details')) {
              tr = tr.prev();
            }

            var row = that.dataTable.row(tr);
            var data = row.data();
            that.$emit(action, data, row, tr, target);
          } else {
            // not a row click, must be other kind of action
            // such as bulk, csv, pdf, etc...
            that.$emit(action, null, null, null, target);
          }
        }
      }); // handle master/details

      if (that.details) {
        // default to render function
        var renderFunc = that.details.render; // must be string template

        if (that.details.template || typeof that.$slots._details === 'function') {
          renderFunc = that.compileTemplate(that.details, that.$slots._details);
        } else if (renderFunc) {
          renderFunc = function renderFunc() {
            return that.details.render.apply(that, Array.prototype.slice.call(arguments));
          };
        } // handle master/details
        // Add event listener for opening and closing details


        $el.on('click', 'td.details-control', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var target = jq(e.target);
          var tr = target.closest('tr');

          if (tr.hasClass('master-details')) {
            tr = tr.prev();
          }

          var row = that.dataTable.row(tr);

          if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('master');
          } else {
            // Open this row
            var data = row.data();
            row.child(renderFunc(data, 'child', row, tr)).show();
            tr.addClass('master').next().addClass('master-details');
          }
        });
      }

      that.$emit('table-created', that); // finally, load data

      if (that.dataLoader) {
        that.reload();
      }
    },
    methods: {
      /**
       * Vue.compile a template string and return the compiled function
       *
       * @param  {Object} object with template property
       * @param  {Object} the slot
       * @return {Function}          the compiled template function
       */
      compileTemplate: function compileTemplate(field, slot) {
        var that = this;
        that.jq;

        var renderFunc = function renderFunc(_data, type, row, meta) {
          var myDynamicComponent = vue.defineComponent({
            data: function data() {
              return {
                data: _data,
                type: type,
                row: row,
                meta: meta,
                vdtnet: that,
                def: field,
                comp: that.$parent
              };
            },
            template: "<div>".concat(field.template || '', "</div>")
          });
          var tempApp = vue.createApp({
            render: function render() {
              if (slot) {
                return vue.h('div', {}, [slot({
                  data: _data,
                  type: type,
                  row: row,
                  meta: meta,
                  vdtnet: that,
                  def: field,
                  comp: that.$parent
                })]);
              }

              return vue.h(myDynamicComponent, {});
            }
          });
          var el = document.createElement('div');
          var mountedApp = tempApp.mount(el);
          return mountedApp.$el.outerHTML || '';
        };

        renderFunc.templated = true;
        return renderFunc;
      },

      /**
       * Set table data array that was loaded from somewhere else
       * This method allow for local setting of data; though, it
       * is recommended to use ajax instead of this.
       *
       * @param {Array} data   the array of data
       * @return {Object}            the component
       */
      setTableData: function setTableData(data) {
        var that = this;

        if (data.constructor === Array) {
          that.dataTable.clear().rows.add(data);
          that.dataTable.draw(false);
          that.dataTable.columns.adjust();
        }

        return that;
      },

      /**
       * pass through reload method
       *
       * @param  {Boolean}  resetPaging true to reset current page position
       * @return {Object}            the component
       */
      reload: function reload() {
        var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var that = this;

        if (that.dataLoader) {
          // manual data loading
          that.dataLoader(function (data) {
            if (data && !data.data) {
              data = {
                data: data
              };
            }

            that.setTableData(data.data);
            that.$emit('reloaded', data, that);
          });
        } else {
          that.dataTable.ajax.reload(function (data) {
            that.$emit('reloaded', data, that);
          }, resetPaging);
        }

        return that;
      },
      search: function search(value) {
        var that = this;
        that.dataTable.search(value).draw();
        return that;
      },
      setPageLength: function setPageLength(value) {
        var that = this;
        that.dataTable.page.len(value);
        return that.reload();
      },
      getServerParams: function getServerParams() {
        if (this.dataLoader) {
          return {};
        }

        return this.dataTable.ajax.params();
      }
    }
  };
  var _hoisted_1 = {
    key: 0,
    type: "checkbox",
    class: "select-all-checkbox d-print-none"
  };
  var _hoisted_2 = ["innerHTML"];
  var _hoisted_3 = ["placeholder"];
  var _hoisted_4 = ["innerHTML"];

  function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.openBlock(), vue.createElementBlock("div", {
      class: vue.normalizeClass($options.classes)
    }, [_cache[0] || (vue.setBlockTracking(-1), _cache[0] = vue.createElementVNode("table", {
      id: $data.tableId,
      ref: "table",
      class: vue.normalizeClass($props.className),
      cellpadding: "0"
    }, [vue.createElementVNode("thead", {
      class: vue.normalizeClass($props.theadClassName)
    }, [vue.createElementVNode("tr", null, [(vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList($data.options.columns, function (field, i) {
      return vue.openBlock(), vue.createElementBlock("th", {
        key: 'head_' + i,
        class: vue.normalizeClass(field.classHeaderName)
      }, [vue.renderSlot(_ctx.$slots, 'HEAD_' + field.name, {
        field: field,
        i: i
      }, function () {
        return [field.name === '_select_checkbox' ? (vue.openBlock(), vue.createElementBlock("input", _hoisted_1)) : (vue.openBlock(), vue.createElementBlock("div", {
          key: 1,
          innerHTML: field.label
        }, null, 8, _hoisted_2))];
      })], 2);
    }), 128))])], 2), !$props.hideTfoot ? (vue.openBlock(), vue.createElementBlock("tfoot", {
      key: 0,
      class: vue.normalizeClass($props.tfootClassName)
    }, [vue.createElementVNode("tr", null, [(vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList($data.options.columns, function (field, i) {
      return vue.openBlock(), vue.createElementBlock("th", {
        key: 'foot_' + i,
        class: vue.normalizeClass(field.classFooterName)
      }, [vue.renderSlot(_ctx.$slots, 'FOOT_' + field.name, {
        field: field,
        i: i
      }, function () {
        return [$props.columnSearch && (field.searchable || typeof field.searchable === 'undefined') ? (vue.openBlock(), vue.createElementBlock("input", {
          key: 0,
          placeholder: field.label,
          class: vue.normalizeClass($props.columnSearchClassName),
          type: "search"
        }, null, 10, _hoisted_3)) : !$props.columnSearch ? (vue.openBlock(), vue.createElementBlock("div", {
          key: 1,
          innerHTML: field.label
        }, null, 8, _hoisted_4)) : vue.createCommentVNode("", true)];
      })], 2);
    }), 128))])], 2)) : vue.createCommentVNode("", true)], 10, ["id"]), vue.setBlockTracking(1), _cache[0])], 2);
  }

  var VdtnetTable = /*#__PURE__*/_export_sfc(_sfc_main, [['render', _sfc_render]]);

  return VdtnetTable;
});